var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3200_2228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 512C397.385 512 512 397.385 512 256C512 114.615 397.385 0 256 0C114.615 0 0 114.615 0 256C0 397.385 114.615 512 256 512Z",
    fill: "#2353A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.03 316.8C387.03 316.8 405.34 132.07 283.62 101.91C283.62 101.91 284.42 98.43 284.26 93.62C283.78 79.28 271.86 67.98 257.51 67.98H248.27C246.08 67.98 244.3 69.76 244.3 71.95V99.76C244.3 99.76 220.06 89.53 206.06 114.3C206.06 114.3 72.1197 64.49 66.0297 176.24C64.1697 210.44 68.8797 232.69 132.13 290.96C139.49 297.75 151.1 297.54 157.83 290.12C163.26 284.13 168.68 273.77 172.13 255.94C181.29 208.55 176.44 135.3 109.12 154.15C109.12 154.15 166.75 106.22 190.44 184.31C214.14 262.4 162.43 322.18 274.46 325.42H296.54C296.54 325.42 299.11 402.83 244.98 393.4C203.24 386.13 231.91 358.81 231.91 358.81L227.01 343.06C227.01 343.06 168.77 341.7 180.74 400.82C193.48 463.74 326.15 467.87 377.86 351.54C377.86 351.54 426.33 350.73 446.26 309.26C446.26 309.26 416.1 329.19 387.02 316.8H387.03Z",
    fill: "#F08100"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3200_2228"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.3d7dec2e29cf7b69f1f42e085467cafd.svg";
export { ForwardRef as ReactComponent };